import { getContract as getContractWagmi } from '@wagmi/core'
import { parseEther } from 'viem'
import config from 'app/configWagmi'
import constants from 'app/constants'
import { getBlockchainErrorStatus } from 'app/util/errorCodes'
import loadAbi from './loadAbi'

/**
 * Mint accessories with wallet provider - note that this is only currently
 * to be used for non-paper based wallets
 *
 * @param {string} walletAddress - the user wallet address
 * @param {object} submissionData - the compiled checkout data
 * @param {object} walletClient - the wallet client
 * @returns {Promise} resolves on completion
 */
const mintAccessoriesWithWallet = async (
  walletAddress,
  submissionData,
  walletClient
) => {
  const { itemIds, itemQuantities, total } = submissionData
  const contractInfo = constants.CONTRACTS.AccessoryCollection
  const { publicClient } = config
  const abiData = await loadAbi(contractInfo.abiUrl)
  const contract = await getContractWagmi({
    address: contractInfo.address,
    abi: abiData.abi,
    walletClient
  })

  let hash
  let transactionInfo

  try {
    const value = parseEther(String(total))

    hash = await contract.write.batchPaidMint({
      args: [itemIds, itemQuantities, walletAddress],
      value
    })

    transactionInfo = await publicClient.waitForTransactionReceipt({ hash })
  } catch (err) {
    console.error(err)

    return getBlockchainErrorStatus(err)
  }

  const success = transactionInfo?.status === 'success'

  return {
    success,
    data: transactionInfo,
    message: !success && 'Transaction failed.'
  }
}

// Export
export default mintAccessoriesWithWallet
